var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureTileIcon03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E6E6FD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 5,
    height: 22,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 24,
    width: 5,
    height: 15,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.64,
    x: 25,
    y: 17,
    width: 14,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 33,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.64,
    x: 25,
    y: 24,
    width: 6,
    height: 6,
    rx: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon03);
export default __webpack_public_path__ + "static/media/feature-tile-icon-03.fda2eb4a3b7cf7c5bfbf65b8d8004bc1.svg";
export { ForwardRef as ReactComponent };